import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useUser } from 'zustand-stores/userEnvironmentStore';
import { fetchNotifications } from 'zustand-stores/userNoficationsStore';

export function useFetchNotificationsOnPageChange() {
  const location = useLocation();

  const { user } = useUser();

  // Fetch notifications on each location change
  useEffect(() => {
    if (user?.hasNotifications) fetchNotifications();
  }, [location.pathname, user?.hasNotifications]);
}
